import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  static targets = ["select"]
  static values = {
    initialSelected: {type: Array, default: []}
  }

  confirm(event) {
    if (!this.hasSelectTarget) return

    const initialValues = new Set(this.initialSelectedValue.map(String))
    const confirmations = Array.from(this.selectTarget.selectedOptions)
      .filter((option) => !initialValues.has(option.value))
      .map((option) => option.dataset.planningContextConfirmation)
      .filter(Boolean)

    if (confirmations.length === 0 || window.confirm([...new Set(confirmations)].join("\n\n"))) return

    event.preventDefault()
    event.stopPropagation()
  }
}
